import * as React from 'react';

let validIcon = require('../../../../../images/form-valid.png');
let invalidIcon = require('../../../../../images/form-error.png');

interface Props {
    children?: React.ReactNode;
    headerText: string;
    onEditClick?: () => void;
    hasIssue?: boolean;
    alwaysShowEditButton?: boolean;
}

export const ConfirmationSection = (props: Props) => {
    return (
        <section className="confirmation-section">
            <header>
                <div>
                    <span>{props.headerText}</span>
                    {props.hasIssue !== undefined && (
                        <img
                            className="valid-or-invalid-icon"
                            src={props.hasIssue ? invalidIcon : validIcon}
                        />
                    )}
                </div>

                {props.onEditClick && (props.hasIssue || props.alwaysShowEditButton) && (
                    <a onClick={props.onEditClick} className="confirmation-section-edit">
                        Edit
                    </a>
                )}
            </header>
            {props.children}
        </section>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/ConfirmationSection.tsx